import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import type { Pinia } from 'pinia';
import { config } from '@/app/core/config';
export function createStore(): Pinia {
  const pinia = createPinia();
  pinia.use(
    createPersistedState({
      key: (id) => `${config.piniaStoreKeyPrefix}${id}`,
      debug: __DEV__,
    }),
  );
  return pinia;
}
